import api from "./axiosInstance";
import apiRoutes from "./api_route";

export const getTokenApi = async (identity, roomName) => {
  const response = await api.post(apiRoutes.token.generate, {
    identity,
    room: roomName,
  });
  return response.data;
};

export const fetchRoomRecordingsApi = async (roomSid) => {
  const response = await api.get(apiRoutes.recordings.listByRoom, {
    params: { roomSid },
  });
  return response.data;
};

export const getAllRecordings = async () => {
  const response = await api.get(apiRoutes.recordings.all);
  return response.data;
};

export const startRecordingApi = async (sid) => {
  const response = await api.post(apiRoutes.recordings.start(sid));
  return response.data;
};

export const stopRecordingApi = async (sid) => {
  const response = await api.post(apiRoutes.recordings.stop(sid));
  return response.data;
};

export const getRecordingsFromDbApi = async (sid) => {
  const response = await api.get(apiRoutes.recordings.fromDb(sid));
  return response.data;
};

export const downloadRecordingApi = async (sid) => {
  const response = await api.get(apiRoutes.recordings.download(sid), {
    responseType: "blob",
  });
  return response.data;
};
